import { BulkMessageModel, CustomerCompanyBasicModel, MessageBasicModel, MessageModel, RoomBasicModel, UserLocationBasicModel } from "@shared/models";
import { FormatDatesService } from "@shared/services";

export class MessageBasic {
  id:         number;
  text:       string;

  createdAt:  Date;
  editedAt:   Date;
  deletedAt:  Date;
  dateString: string;
  constructor(data: MessageBasicModel) {
    this.id         = data.id   ? data.id   : null;
    this.text       = data.text ? data.text : null;

    this.createdAt  = FormatDatesService.parseDate(data.created_at);
    this.editedAt   = FormatDatesService.parseDate(data.edited_by_author_at);
    this.deletedAt  = FormatDatesService.parseDate(data.deleted_at);
    this.dateString = this.createdAt.toISOString().slice(0, 10);
  }

  toJSON(): MessageBasicModel {
    return {
      id:                  this.id        ? this.id                                         : null,
      text:                this.text      ? this.text                                       : null,

      created_at:          this.createdAt ? FormatDatesService.parseDateISO(this.createdAt) : null,
      edited_by_author_at: this.editedAt  ? FormatDatesService.parseDateISO(this.editedAt)  : null,
      deleted_at:          this.deletedAt ? FormatDatesService.parseDateISO(this.deletedAt) : null,
    };
  }

}

export class Message extends MessageBasic {
  myParticipantId: number;
  seq:             number;
  bulkMessageId:   number;
  participantId:   number;
  viewerIds:       number[];
  constructor(data: MessageModel, participantId: number) {
    super(data);

    this.myParticipantId = data.myParticipantId || participantId ? data.myParticipantId || participantId : null;
    this.bulkMessageId   = data.bulk_message_id ? data.bulk_message_id : null;
    this.seq             = data.seq             ? data.seq             : null;
    this.participantId   = data.participant_id  ? data.participant_id  : null;
    this.viewerIds       = data.viewer_ids      ? data.viewer_ids      : [];
  }

  get isOwnMessage(): boolean {
    return !this.bulkMessageId && this.participantId === this.myParticipantId;
  }

  toJSON(): MessageModel {
    return Object.assign(super.toJSON(), {
      myParticipantId: this.myParticipantId ? this.myParticipantId : null,
      participant_id:  this.participantId   ? this.participantId   : null,
      bulk_message_id: this.bulkMessageId   ? this.bulkMessageId   : null,
      seq:             this.seq             ? this.seq             : null,
      viewer_ids:      this.viewerIds       ? this.viewerIds       : []
    });
  }

}

export class BulkMessage extends MessageBasic {
  kind:              string;

  roomIds:           number[];
  companyIds:        number[];
  locationIds:       number[];

  recipient:         string;

  notifiedRooms:     RoomBasicModel[];
  notifiedLocations: UserLocationBasicModel[];
  notifiedCompanies: CustomerCompanyBasicModel[];
  constructor(data: BulkMessageModel) {
    super(data);

    this.kind              = data.kind               ? data.kind               : null;

    this.roomIds           = data.room_ids           ? data.room_ids           : null;
    this.companyIds        = data.company_ids        ? data.company_ids        : null;
    this.locationIds       = data.location_ids       ? data.location_ids       : null;

    this.notifiedRooms     = data.notified_rooms     ? data.notified_rooms     : null;
    this.notifiedLocations = data.notified_locations ? data.notified_locations : null;
    this.notifiedCompanies = data.notified_companies ? data.notified_companies : null;

    let limit = 64;
    this.recipient = this.collectRecipients();
    if (this.recipient.length > limit) this.recipient = this.recipient.slice(0, limit)+'...';
  }

  get recipientNames(): string[] {
    if (this.kind === 'room'    ) return this.notifiedRooms?.map(r => r.room_name)                       || [];
    if (this.kind === 'location') return this.notifiedLocations?.map(r => `${r.city} (${r.identifier})`) || [];
    if (this.kind === 'company' ) return this.notifiedCompanies?.map(r => r.name)                        || [];
    return [];
  }

  private collectRecipients(): string {
    return this.recipientNames.join(', ');
  }

  toJSON(): BulkMessageModel {
    return Object.assign(super.toJSON(), {
      kind:               this.kind              ? this.kind              : null,

      room_ids:           this.roomIds           ? this.roomIds           : null,
      company_ids:        this.companyIds        ? this.companyIds        : null,
      location_ids:       this.locationIds       ? this.locationIds       : null,

      notified_rooms:     this.notifiedRooms     ? this.notifiedRooms     : null,
      notified_companies: this.notifiedCompanies ? this.notifiedCompanies : null,
      notified_locations: this.notifiedLocations ? this.notifiedLocations : null,
    });
  }

}
